import React, { useRef } from 'react';
// nodejs library that concatenates classes
import axios from 'axios';
import moment from 'moment';
import { groupBy } from 'ramda';
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { appState } from '../../AppState';
import useAsyncEffect from '../../utility/use-async-effect';
import { ClipboardCopyButton } from '../misc';
import useTriaTicketsState from './ConnectriaTicketsState';

import { Doughnut } from 'react-chartjs-2';
import FileService from '../../services/FileService';
import PortalService from '../../services/PortalService';
import SentimentService from '../../services/SentimentService';
import { Inbox } from '../ConnectriaTickets/ConnectriaTicketsDashboard';
import AutoCompleteSelectForm from '../InputComponents/AutoCompleteSelectForm';
import { ExpandingTextArea } from '../misc';
import { NewTabLink, TicketBladeContainer } from './ConnectriaTicketsBlade';
// reactstrap components
import 'chartjs-plugin-labels';
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from 'reactstrap';
import ConnectriaTicketsService from '../../services/ConnectriaTicketsService';
import CookieService from '../../services/CookieService';
import ScreenshotService from '../../services/ScreenshotService';
import YetiServices from '../../services/YetiServices';
import YetiTicketProvider from '../../services/YetiTickets';
import { PROVIDERS } from './constants';
import { getMetrics, prependServiceIdToDescription } from './utils';
import { Button } from '../Marketing/Button/Button';
import Attachments from '../Attachments/Attachments';

const MAX_ATTACHMENT_SIZE_MB = 4.4;

const NewTicketForm = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [types, setTypes] = useState();
  const [priorities, setPriorities] = useState();
  const [categories, setCategories] = useState();
  const [devices, setDevices] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState({});
  const [subject, setSubject] = useState();
  const [cc, setCC] = useState();
  const [ticketType, setTicketType] = useState(null);
  const [ticketPriority, setTicketPriority] = useState();
  const [ticketCategory, setTicketCategory] = useState();
  const [ticketSubCategory, setTicketSubCategory] = useState();
  const [ticketDevice, setTicketDevice] = useState();
  const [description, setDescription] = useState();
  const [ticketError, setTicketError] = useState();
  const [isCreating, setIsCreating] = useState(false);
  const [attachmentElementId, setAttachmentElementId] = useState();
  const [carbonCopies, setCarbonCopies] = useState([]);
  const [defaultCarbonCopies, setDefaultCarbonCopies] = useState([]);
  const [customerActiveUsers, setCustomerActiveUsers] = useState([]);
  const [ticketMeta, setTicketMeta] = useState([]);
  const [includeCSM, setIncludeCSM] = useState(false);
  const [csmInfo, setCsmInfo] = useState(null);
  const [hasIncludeCsmMeta, setHasIncludeCsmMeta] = useState(false);
  const [descriptionInvalid, setDescriptionInvalid] = useState(false);
  const [errorsInvalid, setErrorsInvalid] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [attachmentError, setAttachmentError] = useState(null);
  const [attachmentUploadError, setAttachmentUploadError] = useState(null);
  //global state
  const [stateApp, stateAppActions] = appState();
  //plugin state
  const [stateTickets, stateTicketActions] = useTriaTicketsState();
  const source = axios.CancelToken.source();
  const history = useHistory();
  
  // TODO: remove this after testing
  console.log('stateApp', stateApp.policies);
  const devicesMap = useMemo(
    () => groupBy((d) => deviceTypes[d.devicetype_id] || 'UNKNOWN')(devices),
    [devices, deviceTypes]
  );

  useAsyncEffect(
    async (isMounted) => {
      try {
        if (!isMounted() || !stateApp.userInfo?.organization_id) return;

        setIsLoading(true);

        var types = await ConnectriaTicketsService.ticketTypes({
          cancelToken: source.token,
        });
        var priorities = ConnectriaTicketsService.ticketPriorities();

        let preferences =
          await ConnectriaTicketsService.getCustomerTicketCarbonCopies(
            { name: 'customerTicketsCarbonCopy' },
            {
              cancelToken: source.token,
            }
          );

        await Promise.all([
          setCacheUsers(preferences),
          setCacheCategories(),
          setCacheDevices(),
          setCsmInfoAndMeta(),
        ]);

        const CCs = preferences.map((cc) => {
          return { user_id: cc };
        });
        setCarbonCopies(CCs);
        setDefaultCarbonCopies(CCs);

        setTypes(types.filter((e) => e.name != 'Problem'));
        setPriorities(priorities);

        setFormDefaults(types[0].id, priorities[2].id);
        //check for passed-in default values
        if (props.subject != null) {
          setSubject(props.subject);
        }
        if (props.category != null) {
          setTicketCategory(props.category);
        }
        if (props.subCategory != null) {
          setTicketSubCategory(props.subCategory);
        }
        if (props.type != null) {
          setTicketType(props.type);
        }
        if (props.description != null) {
          setDescription(props.description);
        }
        if (props.attachmentElementId != null) {
          setAttachmentElementId(props.attachmentElementId);
        }
        if (props.deviceId) {
          //lookup by asset tage
          const _devices =
            (await ConnectriaTicketsService.getAllDevicesLike(
              {
                select: 'id,assettag,servicetag,devicetype_id',
                id: props.deviceId,
                limit: 1,
              },
              { cancelToken: source.token }
            )) || [];

          if (_devices.length > 0) {
            setDevices((ds) =>
              ds?.find((d) => `${d.id}` === `${props.deviceId}`)
                ? ds
                : [..._devices, ...ds]
            );
            setTicketDevice(_devices[0].assettag);
          }
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // request cancelled
        } else {
          throw error;
        }
      }
    },
    () => {
      source.cancel();
    },
    [stateApp.userInfo]
  );

  const setCacheCategories = async () => {
    //if cache is still loading set a half second timeout and call again

    let categories = await ConnectriaTicketsService.ticketCategories({});
    categories.names = [
      ...new Set(
        categories.map((category) => {
          return category.name;
        })
      ),
    ];
    setCategories(categories);
  };

  const setCacheDevices = async () => {
    //if cache is still loading set a half second timeout and call again
    const _devices = await ConnectriaTicketsService.getAllDevicesLike(
      {
        select: 'id,assettag,servicetag,devicetype_id',
        limit: 10000,
        sort_by: 'assettag',
      },
      { cancelToken: source.token }
    );

    if (_devices?.length) {
      const allDeviceTypes = await ConnectriaTicketsService.getAllDeviceTypes(
        {
          select: 'id,category',
          limit: 10000,
        },
        { cancelToken: source.token }
      );
      const deviceTypes = allDeviceTypes.reduce(
        (r, dt) => ({ ...r, [dt.id]: dt.category }),
        {}
      );

      setDeviceTypes(deviceTypes);
    }

    setDevices(_devices || []);
  };

  const setCacheUsers = async (preferences) => {
    let isCustomer = stateApp.userInfo.organization_id != 0;
    var users = await ConnectriaTicketsService.getAllUsersLike({}, isCustomer);
    for (var user of users) {
      if (preferences.includes(user.id)) {
        user['selected'] = true;
      } else {
        user['selected'] = false;
      }
    }
    users.sort((a, b) => {
      return a.fname.localeCompare(b.fname);
    });

    const ccUsers = users.filter(
      (user) =>
        user.active &&
        user.login_supported &&
        !user.serviceUser &&
        user.email !== stateApp.userInfo?.email
    );
    preferences = preferences.filter(
      (p) => ccUsers.findIndex((u) => u.id === p) !== -1
    );

    setCustomerActiveUsers(ccUsers);
  };
  const setFormDefaults = (ticketTypeId, ticketPriorityId) => {
    setTicketType(null);
    setTicketPriority(ticketPriorityId);
    setTicketCategory('');
    setTicketSubCategory('');
    setTicketDevice('');
    setSubject('');
    setDescription('');
    setIncludeCSM(false);
    setTicketError('');
    setDescriptionInvalid(false);
    setErrorsInvalid(false);
    setIncludeCSM(false);
    setIsLoading(false);
  };
  const createSentimentMeta = async (ticket_id, text) => {
    let sentiment = await SentimentService.getSentiment(text);
    let value = JSON.stringify({
      ...sentiment.data.SentimentScore,
      readable: sentiment.data.Sentiment,
    });
    //fire and forget
    ConnectriaTicketsService.createTicketMeta(ticket_id, 'sentiment', value);
  };
  const handleCreate = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setIsCreating(true);
    setAttachmentUploadError(null);
    try {
      // Pre-convert attachments to base64, abort entirely if any fail.
      const base64Attachments = [];
      for (const file of attachments) {
        try {
          const fileBase64 = await FileService.toBase64(file);
          base64Attachments.push({ file, fileBase64 });
        } catch (err) {
          setAttachmentUploadError('File upload failed. Please verify the file is valid.');
          setAttachments([]); // clear only attachments
          setIsCreating(false);
          return; // Do NOT create ticket
        }
      }

      // Create ticket only after assurance that all attachments were transformed successfully
      var ticketId = await ConnectriaTicketsService.createTicket(
        subject,
        description,
        ticketError,
        ticketPriority,
        ticketType,
        ticketDevice,
        carbonCopies,
        ticketSubCategory,
        ticketMeta
      );

      //add new ticket to inbox
      var detail = await ConnectriaTicketsService.ticketDetail(ticketId);
      stateTicketActions.unshiftTicket(detail);

      // Upload attachments. If any individual upload fails, show banner, clear attachments, and allow user to decide next steps (ticket already exists).
      for (const { file, fileBase64 } of base64Attachments) {
        try {
          const success = await ConnectriaTicketsService.addAttachment(
            ticketId,
            file.name,
            fileBase64
          );
          if (!success) {
            throw new Error('upload failed');
          }
        } catch (err) {
          // Remove ticket from inbox so user perceives ticket not created; backend rollback not available
          stateTicketActions.removeTicket(ticketId);
          setAttachmentUploadError('File upload failed. Please verify the file is valid.');
          setAttachments([]);
          setIsCreating(false);
          return; // stop further processing but keep populated form fields (except attachments)
        }
      }

      setFormDefaults(null, priorities[2].id);
      resetDefaultCarbonCopies();

      if (!props.closeOnSuccess && !props.fullPage) {
        stateAppActions.setAlert({
          content: (
            <p style={{ color: 'white' }}>
              Ticket #{ticketId} created successfully.
            </p>
          ),
          className: 'success',
          visible: true,
        });
        setTimeout(() => {
          stateAppActions.setAlert((prevState) => ({
            ...prevState,
            visible: false,
          }));
        }, 2000);
      }

      createSentimentMeta(ticketId, description);

      if (attachmentElementId) {
        let ssData = await ScreenshotService.createScreenshotBase64(
          attachmentElementId
        );
        await ConnectriaTicketsService.newComment(
          ticketId,
          'Auto-generated screenshot.',
          'TRiAScreenshot.png',
          ssData
        );
      }
      if (props.closeOnSuccess) {
        stateAppActions.setBlade({
          visible: false,
          content: '',
          title: '',
        });
      }
      if (props.fullPage) {
        history.push(`/app/view/ticket/${ticketId}`);
      }
    } catch (error) {
      console.log(error);
      stateAppActions.setAlert({
        content: <p style={{ color: 'white' }}>Error creating ticket.</p>,
        color: 'danger',
        visible: true,
      });
      setTimeout(() => {
        stateAppActions.setAlert((prevState) => ({
          ...prevState,
          visible: false,
        }));
      }, 2000);
    }
    setIsCreating(false);
  };

  const resetDefaultCarbonCopies = () => {
    var users = [...customerActiveUsers];
    const preferences = defaultCarbonCopies.map((cc) => {
      return cc.user_id;
    });
    for (var user of users) {
      if (preferences.includes(user.id)) {
        user.selected = true;
      } else {
        user.selected = false;
      }
    }
    setCustomerActiveUsers(users);
  };

  const handleCCSelect = (selectedUser) => {
    var usersCopy = [...customerActiveUsers];
    var newCarbonCopies = [];
    if (selectedUser === 'Select All') {
      usersCopy.forEach((user) => {
        user.selected = true;
      });
      newCarbonCopies = usersCopy.map((user) => ({ user_id: user.id }));
      setCarbonCopies(newCarbonCopies);
    } else if (selectedUser === 'Deselect All') {
      usersCopy.forEach((user) => {
        user.selected = false;
      });
      setCarbonCopies([]);
    } else {
      for (const user of usersCopy) {
        if (user.id === selectedUser.id) {
          user.selected = !user.selected;
        }
        if (user.selected) {
          newCarbonCopies.push({ user_id: user.id });
        }
      }
      setCarbonCopies(newCarbonCopies);
    }
    setCustomerActiveUsers(usersCopy);
  };

  const handleCsmSelect = () => {
    if (includeCSM) {
      setTicketMeta(ticketMeta.filter((meta) => meta.meta_key !== 'notify_csm'));
    } else {
      setTicketMeta([
        ...ticketMeta,
        { meta_key: 'notify_csm', meta_value: '1' },
      ]);
    }
    setIncludeCSM(!includeCSM);
  };

  const setCsmInfoAndMeta = async () => {
    try {
      let [accountAgents, metadata] = await Promise.all([
        ConnectriaTicketsService.getParamData({ cancelToken: source.token }),
        PortalService.getPortalCustomerMeta({ meta_key: 'tria_show_cc_csm' }),
      ]);
      accountAgents =
        accountAgents.dynamic.response.data.customer_account_agents || [];

      for (var agent of accountAgents) {
        if (agent.agent_type.name === 'Customer Success Manager') {
          setCsmInfo(agent);
        }
      }
      if (metadata.meta_value === 'TRUE') {
        setHasIncludeCsmMeta(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDescriptionChange = (value) => {
    try {
      // Check if string is valid utf-8
      decodeURIComponent(escape(value));
      // If so, the text is valid
      setDescriptionInvalid(false);
    } catch (e) {
      // If the text is not valid utf-8 then display message to user
      setDescriptionInvalid(true);
    }
    setDescription(value);
  };

  const handleErrorsChange = (value) => {
    try {
      // Check if string is valid utf-8
      decodeURIComponent(escape(value));
      // If so, the text is valid
      setErrorsInvalid(false);
    } catch (e) {
      // If the text is not valid utf-8 then display message to user
      setErrorsInvalid(true);
    }
    setTicketError(value);
  };

  if (isLoading) {
    return (
      <div className="text-center w-100 h-100">
        <i
          className="fas fa-spinner m-3 mt-4 fa-spin"
          style={{ fontSize: "30px" }}
        />
      </div>
    );
  } else {
    return (
      <>
        {attachmentUploadError && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            {attachmentUploadError}
            <button
              type="button"
              className="close"
              onClick={() => setAttachmentUploadError(null)}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        )}
        <div className="h-100 w-100 d-flex connectria-new-ticket-form-contain">
          <Form
            onSubmit={(e) => handleCreate(e)}
            className="d-flex w-100 flex-column"
          >
            <Row className="h-100">
              <Col lg={props.fullPage ? "7" : "6"} md="12">
                <Label className="font-weight-bold">Subject*</Label>
                <Input
                  type="text"
                  id="txtSubject"
                  maxLength={255}
                  onChange={(e) => setSubject(e.target.value)}
                  value={subject}
                  autoComplete="off"
                  required
                />
                <div>
                  <Label className="font-weight-bold" for="txtDescription">
                    Description*
                  </Label>
                  <ExpandingTextArea
                    id="txtDescription"
                    onChange={(e) => handleDescriptionChange(e.target.value)}
                    value={description}
                    rows={props.textAreaRows}
                    required
                    valid={!descriptionInvalid}
                    invalid={descriptionInvalid}
                  />
                  <FormFeedback invalid="true">
                    This text is not valid UTF-8. Ticket creation might fail.
                  </FormFeedback>
                </div>
                <div>
                  <Label for="txtErrors">Error(s)</Label>
                  <ExpandingTextArea
                    id="txtErrors"
                    onChange={(e) => handleErrorsChange(e.target.value)}
                    value={ticketError}
                    rows={props.textAreaRows}
                    valid={!errorsInvalid}
                    invalid={errorsInvalid}
                  />
                  <FormFeedback invalid="true">
                    This text is not valid UTF-8. Ticket creation might fail.
                  </FormFeedback>
                </div>
              </Col>
              <Col lg={props.fullPage ? "5" : "6"} md="12">
                <Label>
                  cc
                  <small
                    className="ml-1"
                    onClick={() => {
                      handleCCSelect("Select All");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    (Select all)
                  </small>
                  <small
                    className="ml-1"
                    onClick={() => {
                      handleCCSelect("Deselect All");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    (Deselect all)
                  </small>
                </Label>
                <div
                  className="form-control resizable"
                  style={{ overflowY: "scroll", height: 100 + "px" }}
                >
                  {customerActiveUsers.map((user, index) => (
                    <div
                      className={"d-flex w-100"}
                      key={index}
                      onClick={(e) => {
                        handleCCSelect(user);
                      }}
                      style={{
                        backgroundColor: user.selected ? "lightblue" : "",
                        cursor: "pointer",
                      }}
                    >
                      <p style={{ flex: "0 50%" }}>
                        {user.fname + " " + user.surname}
                      </p>
                      <p style={{ flex: "0 50%" }}>{"<" + user.email + ">"}</p>
                    </div>
                  ))}
                </div>
                {hasIncludeCsmMeta && (
                  <div className="position-relative form-check mb-1">
                    <label className="form-check-label">
                      <nobr>
                        cc {csmInfo.user.fname + " " + csmInfo.user.surname}
                      </nobr>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={includeCSM}
                        onChange={handleCsmSelect}
                      />
                      <span className="form-check-sign">
                        <span className="check" />
                      </span>
                    </label>
                  </div>
                )}
                <Row>
                  <Col md="6">
                    <Label className="font-weight-bold">Type*</Label>
                    <Input
                      required
                      type="select"
                      id="ddTicketType"
                      onChange={(e) => setTicketType(e.target.value)}
                      value={ticketType == null ? "" : ticketType}
                    >
                      <option
                        value={""}
                        data-content={"<span>Relish ex</span>"}
                      />
                      {types.map((type, index) => (
                        <option key={index} value={type.id}>
                          {type.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md="6">
                    <Label className="font-weight-bold">Priority*</Label>
                    <Input
                      type="select"
                      id="ddTicketPriority"
                      onChange={(e) => setTicketPriority(e.target.value)}
                      value={ticketPriority}
                    >
                      {priorities.map((priority, index) => (
                        <option key={index} value={priority.id}>
                          {priority.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Label className="font-weight-bold">Category*</Label>
                    <Input
                      type="select"
                      id="ddTicketCategory"
                      required
                      onChange={(e) => setTicketCategory(e.target.value)}
                      value={ticketCategory}
                    >
                      <option value="" />
                      {categories.names.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md="6">
                    <Label className="font-weight-bold">Sub-Category*</Label>
                    <Input
                      type="select"
                      id="ddTicketSubCategory"
                      required
                      onChange={(e) => setTicketSubCategory(e.target.value)}
                      value={ticketSubCategory}
                    >
                      <option value="" />
                      {categories
                        .filter((category) => category.name === ticketCategory)
                        .sort((a, b) =>
                          a.subcategory.localeCompare(b.subcategory)
                        )
                        .map((category, index) => (
                          <option key={index} value={category.id}>
                            {category.subcategory}
                          </option>
                        ))}
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Label>Device (Asset Tag - Service Tag)</Label>
                    <Input
                      type="select"
                      id="ddTicketDevice"
                      onChange={(e) => setTicketDevice(e.target.value)}
                      value={ticketDevice}
                    >
                      <option value="">Choose a device...</option>
                      {Object.keys(devicesMap).map((cat) => (
                        <optgroup key={cat} label={cat}>
                          {devicesMap[cat].map((dv) => (
                            <option key={dv.id} value={dv.assettag}>
                              {dv.assettag} - {dv.servicetag}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Label className="font-weight-bold">Attachments</Label>
                    <Attachments
                      attachments={attachments}
                      setAttachments={setAttachments}
                      maxSizeMB={MAX_ATTACHMENT_SIZE_MB}
                      error={attachmentError}
                      setError={setAttachmentError}
                      label="Attachment(s)"
                    />
                  </Col>
                  <Col sm="12" md="6">
                    <div className="text-right mt-4">
                      <Button
                        type="submit"
                        disabled={isCreating}
                        icon={isCreating ? "fas fa-spinner fa-spin" : ""}
                        size="sm"
                      >
                        {isCreating ? "Creating" : "Submit"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <small className="font-weight-bold" style={{ color: "#0C618D" }}>
              * Required
            </small>
          </Form>
        </div>
      </>
    );
  }
};

/**
 * Custom React hook to fetch and manage device data and device types associated with a given organization.
 *
 * This hook retrieves a list of devices and device types from an external service and maps device types to devices.
 * It also provides memoized mappings of devices with their types and a device map for quick lookups.
 *
 * @param {string} organizationId - The ID of the organization for which to fetch devices and device types.
 * @param {boolean} [skip=false] - A flag to skip the fetching process. If true, the fetching logic will not execute.
 * @returns {Object} - The hook returns an object with the following properties:
 * @returns {boolean} isLoading - Indicates whether the data is currently being loaded.
 * @returns {Object} deviceMap - A map of device IDs to their descriptions (e.g., `{ '6567': 'Ccx-PRD-VDA8 - Ccx-PRD-VDA8' }`).
 * @returns {Array<Object>} devicesWithTypes - An array of devices with their associated type names and descriptions.
 *
 * @example
 * const { isLoading, deviceMap, devicesWithTypes } = useDeviceData('org123');
 *
 * devicesWithTypes example output:
 * [
 *   {
 *     id: 6569,
 *     devicetype_id: 38,
 *     assettag: 'Aaron_Windows_Test',
 *     servicetag: 'Aaron_Windows_Test',
 *     type_name: 'VIRTUALMACHINE',
 *     description: 'Aaron_Windows_Test - Aaron_Windows_Test'
 *   }
 * ]
 *
 * deviceMap example output:
 * {
 *   '6567': 'Ccx-PRD-VDA8 - Ccx-PRD-VDA8',
 *   '6568': 'Pkustom-VM7 - Pkustom-VM7'
 * }
 */
const useDeviceData = (organizationId, skip = false) => {
  const [devices, setDevices] = useState([]);
  const [deviceTypes, setDeviceTypes] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!organizationId || skip) return;

    const fetchDevicesAndTypes = async () => {
      try {
        setIsLoading(true);

        const [deviceList, deviceTypeList] = await Promise.all([
          ConnectriaTicketsService.getAllDevicesLike(
            {
              select: 'id,assettag,servicetag,devicetype_id',
              limit: 10000,
              sort_by: 'assettag',
            }
            // { cancelToken }
          ),
          ConnectriaTicketsService.getAllDeviceTypes(
            {
              select: 'id,category',
              limit: 10000,
            }
            // { cancelToken }
          ),
        ]);

        const types = deviceTypeList.reduce((acc, { id, category }) => {
          acc[id] = category;
          return acc;
        }, {});

        setDevices(deviceList || []);
        setDeviceTypes(types);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error('Error fetching devices or device types:', error);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchDevicesAndTypes();
  }, [organizationId, skip]);

  const devicesWithTypes = useMemo(
    () =>
      devices.map((device) => ({
        ...device,
        type_name: deviceTypes[device.devicetype_id],
        description: `${device.assettag} - ${device.servicetag}`,
      })),
    [devices, deviceTypes]
  );

  const deviceMap = useMemo(
    () =>
      devicesWithTypes.reduce((acc, device) => {
        acc[device.id] = device.description;
        return acc;
      }, {}),
    [devicesWithTypes]
  );

  return { isLoading, deviceMap, devicesWithTypes, setDevices };
};

const LETicketForm = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [types, setTypes] = useState([]);
  const [services, setServices] = useState([]);
  const [priorities, setPriorities] = useState([
    { id: 0, name: 'Urgent', value: 'critical' },
    { id: 1, name: 'High', value: 'high' },
    { id: 2, name: 'Normal', value: 'moderate' },
    { id: 3, name: 'Low', value: 'low' },
  ]);
  const [subject, setSubject] = useState();
  const [ticketType, setTicketType] = useState(null);
  const [ticketPriority, setTicketPriority] = useState('critical');
  const [description, setDescription] = useState();
  const [isCreating, setIsCreating] = useState(false);
  const [descriptionInvalid, setDescriptionInvalid] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [attachmentError, setAttachmentError] = useState(null);
  const [attachmentUploadError, setAttachmentUploadError] = useState(null);
  //global state
  const [stateApp, stateAppActions] = appState();
  //plugin state
  const [stateTickets, stateTicketActions] = useTriaTicketsState();
  const source = axios.CancelToken.source();
  const history = useHistory();
  const contactId = stateApp?.userInfo?.external_id || null; // 'ACT-20008313';
  // hybdrid orgs have devices
  const [ticketDevice, setTicketDevice] = useState();
  const {
    isLoading: isDeviceLoading,
    deviceMap,
    devicesWithTypes,
    setDevices,
  } = useDeviceData(stateApp.userInfo?.organization_id, !stateApp.isHybrid);

  // Compute if we have devices or services
  const hasDevices = useMemo(() => devicesWithTypes?.length > 0, [devicesWithTypes]);
  const hasServices = useMemo(() => services?.length > 0, [services]);

  // console.log('------------------------- userInfo ConnectriaTicketsSupportDashboard', JSON.stringify(stateApp?.userInfo));

  useAsyncEffect(
    async (isMounted) => {
      try {
        if (!isMounted() || !stateApp.userInfo?.organization_id) return;

        setFormDefaults(priorities[2].value);
        //check for passed-in default values
        if (props.subject != null) {
          setSubject(props.subject);
        }
        if (props.description != null) {
          setDescription(props.description);
        }
        if (props.deviceId) {
          //lookup by asset tage
          const _devices =
            (await ConnectriaTicketsService.getAllDevicesLike(
              {
                select: 'id,assettag,servicetag,devicetype_id',
                id: props.deviceId,
                limit: 1,
              },
              { cancelToken: source.token }
            )) || [];

          if (_devices.length > 0) {
            setDevices((ds) => (ds?.find((d) => `${d.id}` === `${props.deviceId}`) ? ds : [..._devices, ...ds]));
            setTicketDevice(_devices[0].assettag);
          }
        }

        setIsLoading(true);

        const servicesResponse = await YetiServices.serviceList();
        const parsedServices = servicesResponse?.data?.results?.map(prependServiceIdToDescription) || [];
        
        setServices(parsedServices);
        setTypes(parsedServices); // Keep types for backward compatibility
        setIsLoading(false);
      } catch (error) {
        if (axios.isCancel(error)) {
          // request cancelled
        } else {
          throw error;
        }
      }
    },
    () => {
      source.cancel();
    },
    [stateApp.userInfo]
  );

  const setFormDefaults = (ticketPriorityId) => {
    setTicketType(null);
    setTicketPriority(ticketPriorityId);
    setSubject('');
    setDescription('');
    setDescriptionInvalid(false);
    setIsLoading(false);
  };

  const handleCreate = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setIsCreating(true);
    setAttachmentUploadError(null);
    try {
      if (!contactId) {
        throw new Error('Contact missing external_id.');
      }

      // Pre-convert attachments to base64 BEFORE creating ticket. Abort if any fail.
      const base64Attachments = [];
      for (const file of attachments) {
        try {
          const fileBase64 = await FileService.toBase64(file);
          base64Attachments.push({ file, fileBase64 });
        } catch (err) {
          setAttachmentUploadError('File upload failed. Please verify the file is valid.');
          setAttachments([]);
          setIsCreating(false);
          return; // do not create ticket
        }
      }

      const ticketDescription = stateApp.isHybrid && deviceMap[ticketDevice] ? `${description} \nDevice: ${deviceMap[ticketDevice]}` : description;
      const createTicketResponse = await YetiTicketProvider.createTicket(contactId, subject, ticketType, ticketDescription, (ticketPriority.toString() || 'moderate').toUpperCase());
      const ticketId = createTicketResponse.data.results;

      // Upload attachments. If any fail, show error, clear attachments, keep form data intact (except attachments) so user can retry manually (cannot rollback ticket).
      for (const { file, fileBase64 } of base64Attachments) {
        try {
          await YetiTicketProvider.createTicketAttachment(
            ticketId,
            contactId,
            file.name,
            file.name,
            fileBase64
          );
        } catch (err) {
          setAttachmentUploadError('File upload failed. Please verify the file is valid.');
          setAttachments([]);
          setIsCreating(false);
          return;
        }
      }

      setFormDefaults(priorities[2].value);

      //add new ticket to inbox
      var detail = await YetiTicketProvider.getTicket(ticketId);
      stateTicketActions.unshiftTicket(
        YetiTicketProvider.parseTicket(detail.data.results)
      );

      if (!props.closeOnSuccess && !props.fullPage) {
        stateAppActions.setAlert({
          content: (
            <p style={{ color: 'white' }}>
              Ticket #{ticketId} created successfully.
            </p>
          ),
          className: 'success',
          visible: true,
        });
        setTimeout(() => {
          stateAppActions.setAlert((prevState) => ({
            ...prevState,
            visible: false,
          }));
        }, 2000);
      }
      if (props.closeOnSuccess) {
        stateAppActions.setBlade({
          visible: false,
          content: '',
          title: '',
        });
      }
      if (props.fullPage) {
        history.push(`/app/view/ticket/${ticketId}`);
      }
    } catch (error) {
      console.log(error);
      stateAppActions.setAlert({
        content: <p style={{ color: 'white' }}>Error creating ticket.</p>,
        color: 'danger',
        visible: true,
      });
      setTimeout(() => {
        stateAppActions.setAlert((prevState) => ({
          ...prevState,
          visible: false,
        }));
      }, 2000);
    }
    setIsCreating(false);
  };

  const handleDescriptionChange = (value) => {
    try {
      // Check if string is valid utf-8
      decodeURIComponent(escape(value));
      // If so, the text is valid
      setDescriptionInvalid(false);
    } catch (e) {
      // If the text is not valid utf-8 then display message to user
      setDescriptionInvalid(true);
    }
    setDescription(value);
  };

  if (isLoading || (stateApp.isHybrid && isDeviceLoading)) {
    return (
      <div className="text-center w-100 h-100">
        <i
          className="fas fa-spinner m-3 mt-4 fa-spin"
          style={{ fontSize: "30px" }}
        />
      </div>
    );
  }
  return (
    <>
      {attachmentUploadError && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {attachmentUploadError}
          <button
            type="button"
            className="close"
            onClick={() => setAttachmentUploadError(null)}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      )}
      <div className="h-100 w-100 d-flex connectria-new-ticket-form-contain">
        <Form
          onSubmit={(e) => handleCreate(e)}
          className="d-flex w-100 flex-column"
        >
          <Row className="h-100">
            <Col lg={props.fullPage ? "7" : "6"} md="12">
              <Label className="font-weight-bold">Subject*</Label>
              <Input
                type="text"
                id="txtSubject"
                maxLength={255}
                onChange={(e) => setSubject(e.target.value)}
                value={subject}
                autoComplete="off"
                required
              />
              <div>
                <Label className="font-weight-bold" for="txtDescription">
                  Description*
                </Label>
                <ExpandingTextArea
                  id="txtDescription"
                  onChange={(e) => handleDescriptionChange(e.target.value)}
                  value={description}
                  rows={props.textAreaRows}
                  required
                  valid={!descriptionInvalid}
                  invalid={descriptionInvalid}
                />
                <FormFeedback invalid="true">
                  This text is not valid UTF-8. Ticket creation might fail.
                </FormFeedback>
              </div>
            </Col>
            <Col lg={props.fullPage ? "5" : "6"} md="12">
              <Row>
                {/* Device Field - Show if hybrid and has devices */}
                {stateApp.isHybrid && hasDevices && (
                  <Col md={hasServices ? "12" : "6"}>
                    <Label className="font-weight-bold">
                      Device (Asset Tag - Service Tag)
                    </Label>
                    <AutoCompleteSelectForm
                      id="ddTicketDevice"
                      value={ticketDevice}
                      onChange={(e) => setTicketDevice(e.target.value)}
                      options={devicesWithTypes}
                      isGrouping
                      groupingAttr={"type_name"}
                    />
                  </Col>
                )}
                
                {/* Service Field - Show if has services */}
                {hasServices && (
                  <Col md={hasDevices ? "12" : "6"}>
                    <Label className="font-weight-bold">Impacted Service</Label>
                    <AutoCompleteSelectForm
                      id="ddTicketType"
                      value={ticketType}
                      onChange={(e) => setTicketType(e.target.value)}
                      options={services}
                      isGrouping
                      groupingAttr={"type_name"}
                    />
                  </Col>
                )}
                
                {/* Priority Field - Always visible */}
                <Col md={hasDevices || hasServices ? "6" : "12"}>
                  <Label className="font-weight-bold">Priority*</Label>
                  <Input
                    type="select"
                    id="ddTicketPriority"
                    onChange={(e) => setTicketPriority(e.target.value)}
                    value={ticketPriority}
                  >
                    {priorities?.map((priority, index) => (
                      <option key={index} value={priority.value}>
                        {priority.name}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Label className="font-weight-bold">Attachments</Label>
                  <Attachments
                    attachments={attachments}
                    setAttachments={setAttachments}
                    maxSizeMB={MAX_ATTACHMENT_SIZE_MB}
                    error={attachmentError}
                    setError={setAttachmentError}
                    label="Attachment(s)"
                  />
                </Col>
                <Col sm="12" md="6">
                  <div className="text-right mt-4">
                    <Button
                      type="submit"
                      disabled={isCreating}
                      icon={isCreating ? "fas fa-spinner fa-spin" : ""}
                      size="sm"
                    >
                      {isCreating ? "Creating" : "Submit"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <small className="font-weight-bold" style={{ color: "#0C618D" }}>
            * Required
          </small>
        </Form>
      </div>
    </>
  );
};

function showItemBlade(item, stateApp, stateAppActions) {
  // TODO: we might need to check if relying on the ID prefix is good enough solution
  // if the id is only numbers then it's a connectria ticket otherwise it's a lightedge one
  const ticketProvider = /^\d+$/.test(item.ticket_id)
    ? PROVIDERS.CONNECTRIA
    : PROVIDERS.LIGHTEDGE;
  stateAppActions.setBlade({
    title: (
      <span>
        {"#" + item.ticket_id}{" "}
        <ClipboardCopyButton
          className="mb-1"
          value={`${window.location.origin}/app/support/ticket/${item.ticket_id}`}
          tooltipMessage={"Copy ticket link"}
          alertMessage={`Ticket #${item.ticket_id} link copied.`}
        />
        <NewTabLink
          tooltipMessage={"Open In New Tab"}
          link={`/app/view/ticket/${item.ticket_id}`}
          alertMessage={""}
        />
      </span>
    ),
    visible: true,
    content: (
      <TicketBladeContainer
        id={item.ticket_id}
        ticketProvider={ticketProvider}
      />
    ),
  });
}

const PriorityPieChart = (props) => {
  const [stateApp] = appState();
  const [isLoading, setIsLoading] = useState(true);
  const [metrics, setMetrics] = useState();

  const source = axios.CancelToken.source();

  const fetchTickets = async () => {
    setIsLoading(true);
    try {
      if (stateApp.orgType === 'CONNECTRIA') {
        const resp = await ConnectriaTicketsService.ticketPriorityMetric(30, {
          cancelToken: source.token,
        });
        setMetrics(resp);
      } else {
        const response = await YetiTicketProvider.getAllTickets();
        const tickets = response.data.results.map(
          YetiTicketProvider.parseTicket
        );
        const metrics = getMetrics(tickets, 30);
        setMetrics(metrics);
      }
    } catch (error) {
      console.error('Error fetching tickets:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  return (
    <Card className="card-minimal mb-0" id="connectria-ticket-priority-card">
      <CardHeader className="card-header-minimal">
        <CardTitle className="card-title-minimal" tag="h3">
          Ticket Priorities
        </CardTitle>
      </CardHeader>
      <CardBody style={{ height: "350px" }}>
        {isLoading ? (
          <div className="text-center">
            <i
              className="fas fa-spinner m-3 mt-4 fa-spin"
              style={{ fontSize: "30px" }}
            />
          </div>
        ) : (
          <>
            <h5>All Tickets Over the Last 30 Days</h5>
            <div style={{ height: "265px" }}>
              <Doughnut
                data={metrics}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    labels: {
                      render: "percentage",
                      fontColor: "white",
                      fontSize: 14,
                      fontStyle: "bold",
                    },
                    datalabels: { display: false },
                  },
                }}
              />
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
};

const RecentUpdates = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [didLoad, setDidLoad] = useState(false);
  const [audit, setAudit] = useState();
  const [cardBodyStyle, setCardBodyStyle] = useState();
  const source = axios.CancelToken.source();
  useAsyncEffect(
    async (isMounted) => {
      try {
        if (props.visible) {
          if (didLoad) {
            return;
          }
          setIsLoading(true);
          let resp = await ConnectriaTicketsService.ticketAudits(15, {
            cancelToken: source.token,
          });

          if (!isMounted()) return;
          setAudit(resp);
          setIsLoading(false);
          setDidLoad(true);
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // request cancelled
        } else {
          throw error;
        }
      }
    },
    () => {
      source.cancel();
    },
    [props.visible]
  );

  return (
    <Card className="card-minimal mb-0" style={cardBodyStyle}>
      <CardHeader className="card-header-minimal">
        <CardTitle className="card-title-minimal" tag="h3">
          Recent Updates
        </CardTitle>
      </CardHeader>
      <CardBody id="connectria-support-recent-updates-body">
        {isLoading ? (
          <div className="text-center">
            <i
              className="fas fa-spinner m-3 mt-4 fa-spin"
              style={{ fontSize: "30px" }}
            />
          </div>
        ) : (
          <div className="list-group" style={cardBodyStyle}>
            {audit.map((item, index) => (
              <a
                onClick={() =>
                  showItemBlade(item, props.stateApp, props.stateAppActions)
                }
                key={index}
                className={`list-group-item list-group-item-action flex-column align-items-start`}
              >
                <p className="mb-1">{item.log}</p>
                <small>
                  {moment(item.date, "YYYY-MM-DDThh:mm:ss.SSSZ").fromNow()}
                </small>
              </a>
            ))}
          </div>
        )}
      </CardBody>
    </Card>
  );
};

const ConnectriaTicketsSupportDashboard = (props) => {
  //local state
  const [activeTab, setActiveTab] = useState('1');
  //plugin state
  const [state, stateActions] = useTriaTicketsState();
  //global state
  const [stateApp, stateAppActions] = appState();

  useEffect(() => {
    //check for ticket route
    let paths = window.location.pathname.split('/');
    if (
      paths != null &&
      paths.length > 2 &&
      paths[paths.length - 2] === 'ticket'
    ) {
      showItemBlade(
        { ticket_id: paths[paths.length - 1] },
        stateAppActions,
        stateAppActions
      );
    }
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const hasViewOnlyAccess = stateApp.policies.includes("VIEW_ONLY_TICKETS");

  return (
    <>
      <h3 className="mb-3 mt-4 tria-header-class">Support & Ticketing</h3>
      <hr />
      {!hasViewOnlyAccess && <Row>
        <Col md="12">
          <Card className="card-minimal mb-0 h-100">
            <CardHeader className="card-header-minimal">
              <CardTitle className="card-title-minimal" tag="h3">
                Create New Ticket
              </CardTitle>
            </CardHeader>
            <CardBody
              id="connectria-support-new-ticket-body"
              className="d-flex flex-column"
            >
              {stateApp.orgType === PROVIDERS.CONNECTRIA &&
              !stateApp.isHybrid ? (
                <NewTicketForm textAreaRows={4} />
              ) : (
                <LETicketForm fullPage={true} />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row> }
      <Card className="card-minimal mb-0 mt-2">
        <CardHeader className="card-header-minimal">
          <CardTitle className="card-title-minimal" tag="h3">
            Ticketing Inbox
          </CardTitle>
        </CardHeader>
        <CardBody id="connectria-support-inbox-body">
          <Inbox
            isLoading={state.isLoading}
            tickets={state.tickets}
            statePlugin={state}
            statePluginActions={stateActions}
            stateApp={stateApp}
            stateAppActions={stateAppActions}
            hasViewOnlyAccess={hasViewOnlyAccess}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default ConnectriaTicketsSupportDashboard;

export { LETicketForm, NewTicketForm };
